export default __webpack_public_path__ + "static/media/G.0cd18a5b.svg";